import React, { useContext } from 'react';
import { PapiCorePackage } from '@wix/da-papi-types';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import CoreMonthlyPriceAndCycle from '../../../../CoreMonthlyPriceAndCycle';

import s from './PackageSublabel.scss';

interface Props {
  corePackage: PapiCorePackage;
  shouldPackageShowDiscount: boolean;
}

const PackageSublabel: React.FC<Props> = ({
  shouldPackageShowDiscount,
  corePackage,
}) => {
  const isMobile = useContext(MobileContext);

  if (!isMobile) {
    return null;
  }

  return (
    <div className={s['root']}>
      {/* larger price with discount */}
      <CoreMonthlyPriceAndCycle
        className={s['bigger-font']}
        corePackage={corePackage}
        priceStyle={'extra-bold'}
        shouldPackageShowDiscount={shouldPackageShowDiscount}
        reverseOrder={
          shouldPackageShowDiscount && corePackage['interval'] === 'month'
        }
      />
      {/* a smaller, strikethrough version of what they -would- have payed w/o discount */}
      {shouldPackageShowDiscount && corePackage['interval'] === 'year' && (
        <CoreMonthlyPriceAndCycle
          className={s['before-discount']}
          corePackage={corePackage}
          showPriceBeforeDiscountOnly
        />
      )}
    </div>
  );
};
PackageSublabel.displayName = 'PackageSublabel';

export default PackageSublabel;
